module.exports = __webpack_public_path__ + "static/media/fast-forward.13963ab2.svg";